import type { QuestionType, SessionResult } from '@mentimeter/http-clients';

export const QUESTION_TYPE_WITHOUT_RESULTS: QuestionType[] = [
  'quiz',
  'quiz_open',
  'quiz_leaderboard',
  'slide',
];

export const POLLING_INTERVAL = 10000;

export const PLACEHOLDER_RESULTS: SessionResult = {
  results: [],
  respondents: 0,
  type: 'slide',
  timestamp: 0,
};
